import Vue from 'vue';
import {
  ENTITY_TYPES,
  setSnapshot,
  setSnapshots,
  removeSnapshot,
  clearSnapshots,
} from '../../../helpers/conflictTracker';

export default {
  SET_CURRENT_JOB(state, newJob) {
    const previousJobId = state.currentJob && state.currentJob._id;
    const newJobId = newJob && newJob._id;
    if (previousJobId && previousJobId !== newJobId) {
      clearSnapshots(ENTITY_TYPES.RAT_ROW);
    }

    if (!state.currentJob || typeof state.currentJob !== 'object') {
      Vue.set(state, 'currentJob', newJob);
      if (newJob && Array.isArray(newJob.repairAssessment)) {
        setSnapshots(ENTITY_TYPES.RAT_ROW, newJob.repairAssessment);
      }
      return;
    }

    const target = state.currentJob;

    if (target && newJob && typeof newJob === 'object') {
      Object.keys(target).forEach((k) => {
        if (!(k in newJob)) Vue.delete(target, k);
      });
    }

    if (newJob && typeof newJob === 'object') {
      Object.keys(newJob).forEach((k) => {
        if (target[k] !== newJob[k]) Vue.set(target, k, newJob[k]);
      });
    }

    if (newJob && Array.isArray(newJob.repairAssessment)) {
      setSnapshots(ENTITY_TYPES.RAT_ROW, newJob.repairAssessment);
    }
  },

  SET_JOB_PROGRESS_TASKS: (state, tasks) => {
    state.jobProgressTasks = tasks;
  },
  DELETE_REPORT_REVISION: (state, revision) => {
    state.currentJob.reports = state.currentJob.reports.filter(
      (rev) => rev.id !== revision.id
    );
  },

  UPSERT_REPAIR_ASSESSMENT_ROW(state, { incoming, forceFields = [] }) {
    if (!state.currentJob) return;
    if (!Array.isArray(state.currentJob.repairAssessment)) {
      Vue.set(state.currentJob, 'repairAssessment', []);
    }

    const list = state.currentJob.repairAssessment;
    const idx = list.findIndex((r) => r.id === incoming.id);

    if (idx === -1) {
      list.push(incoming);
      setSnapshot(ENTITY_TYPES.RAT_ROW, incoming);
      return;
    }

    const target = list[idx];
    const dirtyMap = state.editingFieldsByRow[incoming.id] || {};
    const force = new Set(forceFields);

    const skipForced = new Set(forceFields);

    Object.keys(target).forEach((k) => {
      if (!(k in incoming) && !dirtyMap[k]) Vue.delete(target, k);
    });

    const withheld = {};
    Object.keys(incoming).forEach((k) => {
      const locallyDirty = !!dirtyMap[k];
      if (locallyDirty && !force.has(k)) {
        withheld[k] = incoming[k];
        return;
      }

      if (skipForced.has(k)) {
        return;
      }

      if (force.has(k) || target[k] !== incoming[k]) {
        Vue.set(target, k, incoming[k]);
      }
    });

    setSnapshot(ENTITY_TYPES.RAT_ROW, incoming);
  },

  MARK_FIELD_DIRTY(state, { rowId, field }) {
    if (!state.editingFieldsByRow[rowId])
      Vue.set(state.editingFieldsByRow, rowId, {});
    Vue.set(state.editingFieldsByRow[rowId], field, true);
  },

  CLEAR_DIRTY_FIELDS(state, { rowId, fields }) {
    const dirty = state.editingFieldsByRow[rowId];
    if (dirty) {
      fields.forEach((f) => Vue.delete(dirty, f));
      if (!Object.keys(dirty).length)
        Vue.delete(state.editingFieldsByRow, rowId);
    }
  },

  DELETE_REPAIR_ASSESSMENT_ROW(state, rowId) {
    if (!state.currentJob || !Array.isArray(state.currentJob.repairAssessment))
      return;

    const idx = state.currentJob.repairAssessment.findIndex(
      (r) => r.id === rowId
    );
    if (idx !== -1) {
      state.currentJob.repairAssessment.splice(idx, 1);
    }
    removeSnapshot(ENTITY_TYPES.RAT_ROW, rowId);
  },

  SET_CURRENT_JOB_REPAIR_ASSESSMENT(state, repairAssessments) {
    state.currentJob.repairAssessment = repairAssessments;
    setSnapshots(ENTITY_TYPES.RAT_ROW, repairAssessments);
  },

  SET_FAVOURITE_CURRENT_JOB(state, job) {
    state.currentJob = job;
  },

  UPDATE_FAVORITE_COUNT(state, { id, newCount }) {
    if (state.currentJob._id === id) {
      state.currentJob.favoriteCount = newCount;
    }
  },
};
